import React, { useState, useEffect } from 'react';
import './AnimatedText.css';

const AnimatedText = () => {
  const roles = ['Builder', 'Engineer', 'Marketer', 'Assistant', 'Developer'];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [previousIndex, setPreviousIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setPreviousIndex(currentIndex);
      
      // Wait for animation out to complete before changing word
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % roles.length);
        setIsAnimating(false);
      }, 400); // Matches the CSS animation duration
      
    }, 3500); // Change less frequently to appreciate the animation

    return () => clearInterval(interval);
  }, [currentIndex]);

  const getAnimationClass = () => {
    const index = isAnimating ? previousIndex : currentIndex;
    return `animation-${index}-${isAnimating ? 'out' : 'in'}`;
  };

  return (
    <span className={`animated-text ${getAnimationClass()}`}>
      {roles[currentIndex]}
    </span>
  );
};

export default AnimatedText; 